module.exports = __webpack_public_path__ + "img/veganesfruehstueck.5538a875.png";